import { combineReducers } from '@ynap/reducer-utils';
import { currencyConversion } from '@ynap/product-details-state';

import detailsState from './response';
import appState from './appState';
import promoState from './promoState';
import deliveryReturnsContentState from './deliveryReturnsContentState';

export default combineReducers({ detailsState, appState, currencyConversion, promoState, deliveryReturnsContentState });
